<template>

    <div>
        <div class="modal fade" id="budgetCategoryModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Categorie {{ edit === false ? 'toevoegen' : 'bewerken' }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="name">Naam</label>
                            <input id="name" maxlength="191" type="text" class="form-control" v-model="form.name" />
                        </div>
                        <div class="form-group">
                            <label>Sub-categorie van</label>
                            <v-select
                                :options="getCategories"
                                label="name"
                                v-model="selectedCategory"
                            ></v-select>
                        </div>
                        <div class="form-group text-right">
                            <button :disabled="!canSubmit" @click="onSubmit" class="btn btn-primary"><i class="mdi mdi-plus"></i><span class="sr-only">Toevoegen</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import moment from 'moment';
    import Lang from '../../../Lang';
    import vSelect from 'vue-select';

    export default {

        components: {
            vSelect,
        },

        computed: {

            canSubmit() {
                return this.form.name !== '' &&
                    false === this.posting;
            },

            getCategories() {
                let categories = [];

                this.categories.forEach(cat => {
                    if (cat.parent === null) {
                        categories.push({
                            name:cat.name,
                            id:cat.uuid,
                        });
                    }
                });

                return categories;
            },

            postData() {
                return {
                    parent:this.selectedCategory !== null ? this.selectedCategory.id : null,
                    name:this.form.name,
                };
            },

        },

        data() {
            return {
                edit:false,
                editurl:null,
                form: {
                    name:'',
                },
                lang:Lang,
                posting:false,
                selectedCategory:null,
            }
        },

        methods: {

            closeModal() {
                $('#budgetCategoryModal').modal('hide');
            },

            onSubmit() {
                //post the form
                this.posting = true;
                axios.post(this.edit === true ? this.editurl : this.addCategoryUri, this.postData)
                .then(() => {
                    this.$snotify.success("De categorie is " + (this.edit === true ? 'gewijzigd' : 'toegevoegd'));
                    this.resetForm();
                    this.closeModal();
                    this.$emit("reloadData");
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het " + (this.edit === true ? 'wijzigen' : 'toevoegen') + " van de categorie"))
                .finally(() => this.posting = false);
            },

            openModal() {
                if (this.edit !== true) {
                    this.resetForm();
                }
                $('#budgetCategoryModal').modal('show');
            },

            resetForm() {
                this.form = {
                    name:'',
                };
                this.selectedCategory = null;
                this.edit = false;
                this.editurl = null;
            },

            setAsEdit(category) {
                this.resetForm();
                this.form.name = category.name;
                this.edit = true;
                this.editurl = category._links.edit;
                if (category.parent !== null) {
                    this.selectedCategory = this.getCategories.filter(cat => cat.id === category.parent)[0];
                }
            },

        },

        name: "BusinessBudgetCategoryFormModal",

        props: {
            addCategoryUri: {
                required:true,
                type:String,
            },
            categories: {
                required:true,
                type:Array,
            },
        },

    }

</script>
